import { VStack } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import Pagination from './Pagination/Pagination'
import PagedBody from './TableLocal/PagedBody'
import TableBody from './TableSections/TableBody'
import TableHeader from './TableSections/TableHeader'

const TableUI = ({
  orderBy,
  orderAsc,
  isLocalPaginated = false,
  prepareRow,
  getTableProps,
  getTableBodyProps,
  headerGroups,
  rows,
  page,
  withPagination,
  paginationProps,
  isSelectable,
  validateSelectable,
  onSort,
  tableStyles,
}) => {
  const bodyProps = useMemo(
    () => ({
      getTableBodyProps,
      rows,
      prepareRow,
      isSelectable,
      page,
    }),
    [getTableBodyProps, isSelectable, rows, prepareRow, page],
  )

  const headerProps = useMemo(
    () => ({
      headerGroups,
      isSelectable,
    }),
    [headerGroups, isSelectable],
  )

  const tableStyle = {
    width: '100%',
    maxHeight: '400px',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'block',
    border: 'solid 1px #D7D7D7',
    ...tableStyles,
  }

  return (
    <VStack w="100%">
      <table {...getTableProps()} style={tableStyle}>
        <TableHeader
          validateSelectable={validateSelectable}
          {...{ orderBy, orderAsc }}
          onClick={onSort}
          {...headerProps}
        />
        {isLocalPaginated ? (
          <PagedBody {...bodyProps} />
        ) : (
          <TableBody {...bodyProps} validateSelectable={validateSelectable} />
        )}
      </table>
      {withPagination &&
        (isLocalPaginated ? page?.length > 0 : rows?.length > 0) && (
          <Pagination {...paginationProps} />
        )}
    </VStack>
  )
}

TableUI.propTypes = {
  getTableBodyProps: PropTypes.func,
  getTableProps: PropTypes.func,
  headerGroups: PropTypes.array,
  isLocalPaginated: PropTypes.bool,
  isSelectable: PropTypes.bool,
  onSort: PropTypes.func,
  orderAsc: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  orderBy: PropTypes.string,
  page: PropTypes.array,
  paginationProps: PropTypes.object,
  prepareRow: PropTypes.func,
  rows: PropTypes.array,
  validateSelectable: PropTypes.func,
  withPagination: PropTypes.bool,
  tableStyles: PropTypes.object,
}

export default TableUI
